/*
 * ATB (page weight, 2026-09): the country picker's list (241 countries, ~214 KB of HTML per picker, over half of
 * every page) is no longer in the page. snippets/country-localization.liquid leaves an empty [data-atb-country-lazy]
 * slot; this script fetches the list from sections/atb-country-list.liquid the first time a picker is about to open
 * (hover, focus, touch or click), puts it in every slot on the page, and handles a country click the way Dawn's
 * localization-form.js does (Dawn binds its item clicks when the page loads, before the list exists). Dawn's search,
 * keyboard navigation and close behaviour all query the list when used, so they work unchanged.
 */
(function () {
  if (window.atbCountryLazy) return;
  window.atbCountryLazy = true;

  var request = null;

  function slots() {
    return document.querySelectorAll('[data-atb-country-lazy]');
  }

  function load() {
    if (request) return request;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // Same path as the page (keeps the market and language), only the list section.
    var url = location.pathname + (location.pathname.indexOf('?') === -1 ? '?' : '&') + 'sections=atb-country-list';
    if (url.charAt(0) !== '/') url = root + url;
    request = fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var html = data && data['atb-country-list'];
        if (!html) throw new Error('empty list');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var lists = doc.querySelectorAll('.country-selector__list > ul');
        if (!lists.length) throw new Error('no list');
        Array.prototype.forEach.call(slots(), function (slot) {
          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(lists, function (ul) { frag.appendChild(ul.cloneNode(true)); });
          slot.replaceWith(frag);
        });
        // A search typed while the list was loading applies now.
        Array.prototype.forEach.call(document.querySelectorAll('localization-form input[name="country_filter"]'), function (input) {
          if (input.value) input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
        });
      })
      .catch(function () {
        request = null; // try again on the next open
        Array.prototype.forEach.call(slots(), function (slot) {
          var p = slot.querySelector('p');
          if (p) p.textContent = 'Could not load the list. Close and try again.';
        });
      });
    return request;
  }

  function isCountryButton(el) {
    var form = el && el.closest && el.closest('localization-form');
    return form && form.querySelector('[data-atb-country-lazy]') && el.closest('.disclosure__button') ? form : null;
  }

  // Start loading as soon as someone reaches for a picker, so it is usually ready by the time it opens.
  ['pointerover', 'focusin', 'touchstart', 'click'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (isCountryButton(e.target)) load();
    }, { passive: true, capture: true });
  });

  // A country click on a list that arrived late (Dawn's own item handlers were bound before it existed).
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('localization-form .country-selector__list a[data-value]');
    if (!a) return;
    var formEl = a.closest('localization-form');
    var input = formEl && formEl.querySelector('input[name="country_code"]');
    var form = formEl && formEl.querySelector('form');
    if (!input || !form) return;
    e.preventDefault();
    input.value = a.dataset.value;
    form.submit();
  });
})();
